import Vue from "vue";
import Router from "vue-router";
import AppHeader from "./layout/AppHeader";
import AppFooter from "./layout/AppFooter";
import home from "./views/Home.vue";
import session from "@/store/session";
import UserService from "./services/user.service";

Vue.use(Router);

let router = new Router({
  linkExactActiveClass: "active",
  mode: 'history', 
  routes: [
    {
      path: "/",
      name: "home",
      components: {
        header: AppHeader,
        default: home,
        footer: AppFooter
      }
    },
    {
      path: '/ouverture/:token',
      name: 'manage-opening',
      meta: { requiresAuth: true },
      components: {
        header: AppHeader,
        default: () => import('./views/ManageOpening.vue'),
        footer: AppFooter
      } 
    },
    {
      path: "/mes-inscriptions/:inscriptionId",
      name: "manage-registration",
      meta: { requiresAuth: true },
      components: {
        header: AppHeader,
        default: () => import("./views/ManageRegistration.vue"),
        footer: AppFooter
      }
    },
    {
      path: '/inscription',
      name: 'Register',
      components: {
        header: AppHeader,
        default: () => import('./views/Register.vue'),
        footer: AppFooter
      }
    },
    {
      path: "/auth/activate",
      name: "email-activation",
      components: {
        header: AppHeader,
        default: () => import("./views/EmailActivation.vue"),
        footer: AppFooter
      }
    },
    {
      path: "/auth/reset-password",
      name: "reset-password",
      components: {
        header: AppHeader,
        default: () => import("./views/ResetPassword.vue"),
        footer: AppFooter
      }
    },
    {
      path: "/profil",
      name: "profile",
      components: {
        header: AppHeader,
        default: () => import("./views/Profile.vue"),
        footer: AppFooter
      },
      meta: { requiresAuth: true }
    },
    {
      path: "/adhesion",
      name: "adhesion",
      components: {
        header: AppHeader,
        default: () => import("./views/Adhesion.vue"),
        footer: AppFooter
      },
      meta: { requiresAuth: true }
    },
    {
      path: "/mes-ouvertures",
      name: "my-openings",
      components: {
        header: AppHeader,
        default: () => import("./views/MyOpenings.vue"),
        footer: AppFooter
      },
      meta: { requiresAuth: true }
    },
    {
      path: "/mes-inscriptions",
      name: "my-registrations",
      components: {
        header: AppHeader,
        default: () => import("./views/MyRegistrations.vue"),
        footer: AppFooter
      },
      meta: { requiresAuth: true }
    },
    {
      path: "/mes-covoiturages",
      name: "my-carpools",
      components: {
        header: AppHeader,
        default: () => import("./views/MyCovoits.vue"),
        footer: AppFooter
      },
      meta: { requiresAuth: true }
    },
    {
      path: "/mon-historique",
      name: "my-history",
      components: {
        header: AppHeader,
        default: () => import("./views/MyHistory.vue"),
        footer: AppFooter
      },
      meta: { requiresAuth: true }
    },
    {
      path: "*",
      name: "not-found",
      components: {
        header: AppHeader,
        default: () => import("./views/NotFound.vue"),
        footer: AppFooter
      }
    },
    {
      path: "/cgu", 
      name: "CGU",
      components: {
        header: AppHeader,
        default: () => import("./views/CGU.vue"),
        footer: AppFooter
      }
    },
    {
      path: "/privacy", 
      name: "Privacy",
      components: {
        header: AppHeader,
        default: () => import("./views/Privacy.vue"),
        footer: AppFooter
      }
    },

  ],
  scrollBehavior: to => {
    if (to.hash) {
      return { selector: to.hash };
    } else {
      return { x: 0, y: 0 };
    }
  }
});

router.beforeEach(async (to, from, next) => {

  // 1. Si la route ne nécessite pas d’être connecté → OK
  if (!to.meta.requiresAuth) {
    return next();
  }

  // 2. Si on a déjà l'utilisateur en mémoire → OK
  if (session.isLoggedIn()) {
    return next();
  }

  console.log("authGuard: pas de session en mémoire, tentative de restauration...");
  // 3. Sinon on tente de restaurer la session depuis le backend
  try {
    await UserService.refreshSession();
    // accès autorisé
    return next(); 
    
  } catch (err) {
    console.error("Erreur authGuard /auth/me :", err);
  }

  // 4. Sinon → non connecté → on ouvre le login
  // on stocke la route demandée pour y revenir après login
  next({ path: "/", query: { login: "required" } });
});

export default router;
